// removed by extract-text-webpack-plugin
module.exports = {"main-content":"cmmpnnYTp6Hra5px1IVD_"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/App.less
 ** module id = 846
 ** module chunks = 0
 **/